export const mockPhotos = [
  {
    id: "1",
    image_url: "https://readdy.ai/api/search-image?query=Afghan%20children%20in%20a%20bright%20classroom%20learning%20with%20books%20and%20notebooks%2C%20natural%20daylight%20streaming%20through%20windows%2C%20warm%20and%20hopeful%20atmosphere%2C%20documentary%20style%20photography%20with%20soft%20shadows%2C%20clean%20composition%2C%20educational%20setting%20in%20rural%20school&width=1400&height=700&seq=photo-slider-01&orientation=landscape",
    alt_text: "Afghan children learning in a classroom",
    caption_en: "Students at our Kabul scholarship program — 2,500+ children supported since 2017",
    caption_ps: "زموږ د کابل سکالرشیپ پروګرام کې زده کوونکي — له ۲۰۱۷ راهیسې له ۲۵۰۰ څخه ډېر ماشومان ملاتړ شوي",
    caption_da: "دانش‌آموزان در برنامه بورسیه کابل ما — بیش از ۲۵۰۰ کودک از سال ۲۰۱۷ حمایت شده‌اند",
    sort_order: 0,
    is_active: true,
  },
  {
    id: "2",
    image_url: "https://readdy.ai/api/search-image?query=Mobile%20medical%20clinic%20in%20rural%20Afghanistan%2C%20doctors%20treating%20patients%20under%20a%20tent%2C%20warm%20natural%20light%2C%20compassionate%20healthcare%20scene%2C%20documentary%20photography%20style%2C%20clean%20composition%2C%20dusty%20but%20hopeful%20environment&width=1400&height=700&seq=photo-slider-02&orientation=landscape",
    alt_text: "Mobile medical clinic treating patients in rural Afghanistan",
    caption_en: "Our mobile health clinic in Nangarhar Province — 12,000+ free consultations provided",
    caption_ps: "په ننګرهار ولایت کې زموږ ګرځنده روغتیايي مرکز — له ۱۲۰۰۰ څخه ډېرې وړیا مشورې ورکړل شوې",
    caption_da: "کلینیک سیار ما در ولایت ننگرهار — بیش از ۱۲۰۰۰ مشاوره رایگان ارائه شده است",
    sort_order: 1,
    is_active: true,
  },
  {
    id: "3",
    image_url: "https://readdy.ai/api/search-image?query=Afghan%20women%20learning%20vocational%20skills%20at%20a%20training%20center%2C%20sewing%20and%20crafting%2C%20bright%20and%20empowering%20atmosphere%2C%20natural%20daylight%2C%20documentary%20style%20photography%2C%20warm%20tones%2C%20clean%20composition&width=1400&height=700&seq=photo-slider-03&orientation=landscape",
    alt_text: "Women at a vocational training center",
    caption_en: "Vocational training center in Herat — empowering Afghan women with skills for independence",
    caption_ps: "په هرات کې د مسلکي زده کړو مرکز — افغان ښځې د خپلواکۍ لپاره مهارتونو سره پیاوړې کول",
    caption_da: "مرکز آموزش حرفه‌ای در هرات — توانمندسازی زنان افغان با مهارت‌های استقلال",
    sort_order: 2,
    is_active: true,
  },
  {
    id: "4",
    image_url: "https://readdy.ai/api/search-image?query=Clean%20water%20well%20being%20installed%20in%20a%20rural%20Afghan%20village%2C%20community%20members%20gathered%20around%2C%20celebration%20and%20joy%2C%20bright%20sunlight%2C%20documentary%20style%2C%20warm%20earthy%20tones%2C%20clean%20composition%2C%20hopeful%20atmosphere&width=1400&height=700&seq=photo-slider-04&orientation=landscape",
    alt_text: "Clean water well installation in a rural village",
    caption_en: "Clean water initiative in Helmand — 18,000+ people now have access to safe drinking water",
    caption_ps: "په هلمند کې د پاکو اوبو نوښت — ۱۸۰۰۰+ خلک اوس خوندي څښاک اوبو ته لاسرسی لري",
    caption_da: "ابتکار آب پاک در هلمند — بیش از ۱۸۰۰۰ نفر اکنون به آب آشامیدنی سالم دسترسی دارند",
    sort_order: 3,
    is_active: true,
  },
  {
    id: "5",
    image_url: "https://readdy.ai/api/search-image?query=Afghan%20refugee%20family%20being%20welcomed%20in%20Canada%2C%20volunteers%20helping%20with%20settlement%2C%20warm%20and%20emotional%20moment%2C%20indoor%20community%20center%2C%20documentary%20style%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20hopeful%20atmosphere&width=1400&height=700&seq=photo-slider-05&orientation=landscape",
    alt_text: "Refugee family being welcomed in Canada",
    caption_en: "Refugee resettlement in Ottawa — 340+ families supported in their new Canadian lives",
    caption_ps: "په اوټاوا کې د کډوالو بیا میشتیدنه — ۳۴۰+ کورنۍ په خپل نوي کاناډایي ژوند کې ملاتړ شوې",
    caption_da: "اسکان مجدد پناهندگان در اتاوا — بیش از ۳۴۰ خانواده در زندگی جدید کانادایی خود حمایت شده‌اند",
    sort_order: 4,
    is_active: true,
  },
];